import React from 'react';

import styled from 'styled-components';
import Colors from "../../template/Colors";

const Button = styled.button `
  width: 130px;
  height: 40px;
  box-shadow: 0px 5px 25px rgba(38, 172, 169, 0.07), 0px 7px 25px rgba(38, 172, 169, 0.08), 0px 10px 15px rgba(0, 0, 0, 0.03);
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.1);
  color: ${Colors.commons.grayLight};
  margin: 0px 10px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  &.active {
      background-color: rgba(0, 0, 0, 0.5);
  };
  @media (max-width: 870px){
    width: 70px;
    height: 40px;
    border-radius: 100px
  }
`;
const Label = styled.span`
  @media (max-width: 870px){
    display: none
  }
`;
class Radio extends React.Component {

  onClick = (value) => {
    const {onChange} = this.props;
    onChange && onChange(value);
  }
  
  render() {
    const { value, label, checked, icon } = this.props;
    const Icon = icon;
    return (
      <Button className={checked ? 'active' : ''} onClick={() => this.onClick(value)}>
        <Icon style={{fontSize:24, verticalAlign: 'middle'}} /> 
        <Label>{label}</Label>
      </Button>
    );
  }
}

class RadioGroup extends React.Component {
  state = {
    options: [],
  }
 
  getChildContext() {
    const {name} = this.props;
    return {radioGroup: {
      name,
      onChange: this.onChange.bind(this)
    }};
  }
  
  onChange(selected, child) {
    this.state.options.forEach(option => {
      if (option !== child) {
        option.setSelected(!selected);
      }
    });
  }
  
  render() {
    const children = React.Children.map(this.props.children, child => {
      child.onChange = this.onChange;
      return React.cloneElement(child, {
        ref: (component => {this.state.options.push(component);}) 
      });
    });
    return <div className="radio-group">{children}</div>;
  }
}

export { 
  Radio,
  RadioGroup,
}